import {MantenimientoGaritasService} from '../../services/mantenimiento-garitas.service';
import {INotificacionesResponse} from '../../modelos/INotificaciones';
import {UtilsService} from '../../../../shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from '../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {Component, OnInit} from '@angular/core';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';
import {NotificacionesService} from '../../services/notificaciones.service';

@Component({
  selector: 'app-notificaciones',
  templateUrl: './notificaciones.component.html',
  styleUrls: ['./notificaciones.component.scss'],
})
export class NotificacionesComponent implements OnInit {
  public loading: boolean = false;

  public DAT_TITULOS: any = moduloGaritas.titulos.notificaciones;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public DAT_AG_GRID: any = moduloGaritas.agGrid;

  public columnDefs: any[] = [];
  public rowData: INotificacionesResponse[] = [];
  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public tituloModal: string;
  public isCreate: boolean = true;

  constructor(
    private _util: UtilsService,
    private mantenimientoGaritasService: MantenimientoGaritasService,
    private notificacionesService: NotificacionesService
  ) {
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'idNotificacion',
        sortable: true,
        filter: true,
        width: 10,
      },
      {
        headerName: 'Descripción',
        field: 'desca',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Motivo',
        field: 'motivo',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Sesión',
        field: 'sesion',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 5,
        cellRendererParams: {
          onClick: this.ver.bind(this),
          label: 'Ver',
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      // {
      //   headerName: '',
      //   cellRenderer: 'buttonRenderer',
      //   width: 40,
      //   cellRendererParams: {
      //     onClick: this.editarGarita.bind(this),
      //     label: this.DAT_BTNS.editar,
      //     colorBoton: this.DAT_BTNCSS.info,
      //   },
      // },
      // {
      //   headerName: '',
      //   cellRenderer: 'buttonRenderer',
      //   width: 40,
      //   cellRendererParams: {
      //     onClick: this.eliminarGarita.bind(this),
      //     label: this.DAT_BTNS.eliminar,
      //     colorBoton: this.DAT_BTNCSS.danger,
      //   },
      // },
    ];
  }

  ver({rowData}) {
    console.log(rowData);

    document.getElementById('idNotificacion').textContent = rowData.idNotificacion;
    document.getElementById('desca').textContent = rowData.desca;
    document.getElementById('motivo').textContent = rowData.motivo;
    document.getElementById('sesion').textContent = rowData.sesion;

    this.openModal();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  }

  ngOnInit(): void {
    this.girdComponent();
    this.obtenerNotificaciones();
  }

  obtenerNotificaciones() {
    this.loading = true;
    this.notificacionesService.obtener().subscribe(
      (resp) => {
        console.log("res", resp)
        // this.rowData = resp;
        this.rowData = [
          {
            idNotificacion: 38,
            desca: "GARITA TESTING",
            motivo: "Prueba",
            sesion: "Testing"
          },
          {
            idNotificacion: 30,
            desca: "GARITA WIKI",
            motivo: "Nuevo",
            sesion: "Parámetro"
          },
        ];
        this.loading = false;
      },
      (error) => {
        this.rowData = [];
        this.loading = false;
      },
    )
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
  }

  openModal() {
    document.getElementById('abrirModalNotificaciones').click();
  }

  closeModal() {
    document.getElementById('cerrarModalNotificaciones').click();
  }
}
